var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "file-chooser-toolbar",
    },
    [
      _vm.showButtons
        ? _c(
            "button",
            {
              staticClass: "button",
              attrs: {
                disabled: !_vm.canAddFolder,
              },
              on: {
                click: _vm.addFolder,
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$gettext("Ordner hinzufügen")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showFolderAdder
        ? _c(
            "form",
            {
              staticClass: "default inline-form",
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "label",
                {
                  attrs: {
                    for: "file-chooser-add-folder",
                  },
                },
                [
                  _vm._v(_vm._s(_vm.$gettext("Ordnername")) + "\n        "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newFolderName,
                        expression: "newFolderName",
                      },
                    ],
                    attrs: {
                      id: "file-chooser-add-folder",
                      type: "text",
                      placeholder: _vm.$gettext("Ordnername"),
                    },
                    domProps: {
                      value: _vm.newFolderName,
                    },
                    on: {
                      input: function input($event) {
                        if ($event.target.composing) return
                        _vm.newFolderName = $event.target.value
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inline-button-group",
                },
                [
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Ordner anlegen"),
                      },
                      on: {
                        click: _vm.createFolder,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "accept",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Abbrechen"),
                      },
                      on: {
                        click: _vm.closeAddFolder,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "decline",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showButtons && !_vm.isFolderChooser
        ? _c(
            "button",
            {
              staticClass: "button",
              on: {
                click: function click($event) {
                  return _vm.$refs.fileInput.click()
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$gettext("Datei hinzufügen")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        ref: "fileInput",
        attrs: {
          type: "file",
          disabled: !_vm.canAddFile,
        },
        on: {
          change: _vm.updateUpload,
        },
      }),
      _vm._v(" "),
      _vm.showUpload
        ? _c(
            "form",
            {
              staticClass: "default inline-form",
              on: {
                submit: function submit($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("label", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$gettext("Datei")) +
                    "\n            "
                ),
                _c("input", {
                  attrs: {
                    title: _vm.$gettext("Datei auswählen"),
                    type: "text",
                    readonly: "",
                  },
                  domProps: {
                    value: _vm.uploadFileName,
                  },
                  on: {
                    click: function click($event) {
                      return _vm.$refs.fileInput.click()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "file-chooser-license",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$gettext("Lizenzauswahl")) +
                      "\n            "
                  ),
                  _c("studip-select", {
                    attrs: {
                      options: _vm.termsOfUse,
                      label: "name",
                      reduce: function reduce(termsOfUse) {
                        return termsOfUse.id
                      },
                      clearable: false,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "open-indicator",
                          fn: function fn(_ref) {
                            var selectAttributes = _ref.selectAttributes
                            return [
                              _c(
                                "span",
                                _vm._b({}, "span", selectAttributes, false),
                                [
                                  _c("studip-icon", {
                                    attrs: {
                                      shape: "arr_1down",
                                      size: 10,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "no-options",
                          fn: function fn() {
                            return [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$gettext(
                                      "Es steht keine Auswahl zur Verfügung."
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "selected-option",
                          fn: function fn(option) {
                            return [
                              _c("studip-icon", {
                                attrs: {
                                  shape: option.attributes.icon,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(option.attributes.name)),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "option",
                          fn: function fn(option) {
                            return [
                              _c("studip-icon", {
                                attrs: {
                                  shape: option.attributes.icon,
                                },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(option.attributes.name)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2406843967
                    ),
                    model: {
                      value: _vm.uploadFileLicense,
                      callback: function callback($$v) {
                        _vm.uploadFileLicense = $$v
                      },
                      expression: "uploadFileLicense",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "inline-button-group",
                },
                [
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Datei hochladen"),
                      },
                      on: {
                        click: _vm.createFile,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "accept",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        title: _vm.$gettext("Abbrechen"),
                      },
                      on: {
                        click: _vm.closeAddFile,
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "decline",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }